export enum BusinessSteps {
  BUSINESS_DIRECTION,
  ECONOMIC_NATURE,
  POINT_EMISSION,
  WAREHOUSE,
}
